import { Component, effect, inject, viewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule, DatePicker } from 'primeng/datepicker';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';
import { DatePickerCustomization } from './datepicker-edit';

@Component({
  selector: 'lib-datepicker-compiled',
  imports: [DatePickerModule, ReactiveFormsModule],
  template: `
    @let widget = widgetService.widget();
    @let formControl = widgetService.formControl();
    @if (widget && formControl) {
      <div
        class="p-fluid flex w-full flex-col gap-2"
        (keydown)="onKeyDown($event)"
      >
        <label for="data" class="whitespace-normal text-justify">{{
          widget.customization.description
        }}</label>
        <p-datepicker
          [autofocus]="false"
          id="data"
          type="date"
          [formControl]="formControl"
          appendTo="body"
          [showOnFocus]="false"
          [iconDisplay]="'input'"
          [showIcon]="true"
          dateFormat="dd/mm/yy"
          class="w-full"
          [fluid]="true"
          #calendar
        />
      </div>
    }
  `,
  styleUrls: ['../style.css'],
  providers: [],
})
export class DatePickerCompiledComponent {
  protected widgetService = inject(
    CompilingWidgetService<DatePickerCustomization>,
  );

  calendar = viewChild<DatePicker>('calendar');

  constructor() {
    effect(() => {
      const calendar = this.calendar();
      if (!calendar) return;

      const widget = this.widgetService.widget();
      if (!widget) return;

      switch (widget.customization.topology) {
        case 1:
          calendar.showTime = true;
          calendar.showSeconds = true;
          break;
        case 2:
          calendar.view = 'month';
          calendar.dateFormat = 'mm/yy';
          break;
        case 3:
          calendar.view = 'year';
          calendar.dateFormat = 'yy';
          break;
      }
    });
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
}
